import angular from 'angular';
/**
 * @future Replace global-bag-display
 */
angular.module('checkout').directive(
    'cartSummaryIcon', [
        '$sce',
        'orderMgr',
        function (
            $sce,
            orderMgr
        ) {
            function link(scope) {
                scope.itemQuantity = '--';
                scope.orderItems = [];

                orderMgr.getEventManager().on(
                    'orderMgr.orderChange',
                    function (order) {
                        scope.orderItems = order.items;
                        scope.itemQuantity = order.itemCount;
                    },
                    'cartDisplayIcon'
                );

                if (!orderMgr.hasOrder()) {
                    orderMgr.refreshOrder();
                } else {
                    var order = orderMgr.getOrder();
                    scope.orderItems = order.items;
                    scope.itemQuantity = order.itemCount;
                }
            }

            return {
                link: link,
                restrict: 'E', // element name
                scope: {},
                template: `
                    <div class="reliv-cart-summary-icon">
                        <a href="/cart#/my-cart">
                            <div class="cart-image">
                                <span class="item-count">{{itemQuantity}}</span>
                            </div>
                        </a>
                    </div>
                `,
            };
        },
    ]
);
